<template>
  <div class="page">
    <a-card title="首页推荐位" :bordered="false" :bodyStyle="{padding:'20px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'20px'}">
      <a-tabs v-model="activeKey" @change="callback">
        <a-tab-pane v-for="item in tabList" :tab="item.homeModularName" :key="item.homeModularClassId"></a-tab-pane>
      </a-tabs>
    </a-card>
    <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
      <a-row slot="title" v-if="activeKey==0">
        <a-col :span="8">
          <span class="card-title">轮播图设置</span>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>1.最多展示6条进行中的内容，超过6条时仅显示排序前6条</span>
            </template>
            <a-icon type="info-circle"/>
          </a-tooltip>
        </a-col>
        <a-col :span="8" :offset="8" style="text-align:right;">
          <a-button type="primary" @click="handleContent(0)">添加新内容</a-button>
        </a-col>
      </a-row>
      <a-row slot="title" v-else>
        <a-col :span="8">
          <a-radio-group :defaultValue="0" @change="onOrderChange">
            <a-radio-button :value="0">全部</a-radio-button>
            <a-radio-button :value="1">进行中</a-radio-button>
            <a-radio-button :value="2">未开始</a-radio-button>
            <a-radio-button :value="3">已结束</a-radio-button>
          </a-radio-group>
          <a-button type="primary" style="margin-left:10px;" @click="handleContent(0)">添加新内容</a-button>
        </a-col>
        <a-col :span="8" :offset="8" class="tr">
          <span>修改栏目名称或开启自动推荐</span>
          <a @click="setRecommendationRules">设置</a>
        </a-col>
      </a-row>
      <custom-paging-dragging-list
        ref="table"
        rowKey="modularDetailId"
        :columns="columns"
        :queryParams="queryParams"
        :requestPromise="loadPromise"
        @draggable="onDraggable"
      >
        <!-- <template slot="sortIdSlots" slot-scope="data">
          <editable-cell :text="data.text" @change="onCellChange(data.record.modularDetailId, $event)" />
        </template> -->
        <div slot="indexSlots" slot-scope="data">{{ data.index + 1 }}</div>
        <template slot="contentSlots" slot-scope="data">
          <span>{{ data.record.modularContentType|getModularContentName }}</span>
        </template>
        <div class="image-table" slot="imageSlots" slot-scope="data">
          <CustomImage width="120" height="50" :imageUrl="data.record.modularDetailImg"></CustomImage>
        </div>
        <div slot="action" slot-scope="data">
          <a @click="handleContent(data.record.modularDetailId)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm
            title="你确定要删除这行内容吗?"
            @confirm="deleteEvent(data.record)">
            <a-icon slot="icon" type="close-circle" style="color: red"/>
            <a>删除</a>
          </a-popconfirm>
        </div>
      </custom-paging-dragging-list>
    </a-card>
    <a-modal title="栏目设置"
             width="800px"
             :visible="visible"
             @ok="handleSubmit"
             @cancel="visible = false"
    >
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="栏目名称" prop="remModularName">
          <a-input style="width: 400px;" v-model="ruleForm.remModularName" :maxLength="8"
                   placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="内容模式">
          <a-radio-group name="radioGroup" v-model="ruleForm.remType">
            <a-radio :value="1">手动推荐</a-radio>
            <a-radio :value="2">自动推荐</a-radio>
            <a-radio :value="3">手动+自动推荐（手动添加内容自动展示）</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="品类来源" prop="remCatalogId" v-if="ruleForm.remType!=1">
          <a-select
            v-model="ruleForm.remCatalogId"
            mode="multiple"
            style="width: 400px;"
            placeholder="请选择"
          >
            <a-select-option v-for="(item,idx) in proTypeList" :value="item.code" :key="idx">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="百货类型"
                           v-if="ruleForm.remType != 1 && ruleForm.remCatalogId && ruleForm.remCatalogId.length && ruleForm.remCatalogId.includes(5)">
          <a-radio-group name="radioGroup" :disabled="!isCloseMerchandise" v-model="ruleForm.commodityType">
            <a-radio :value="0">全部</a-radio>
            <a-radio :value="1">普通商品</a-radio>
            <a-radio :value="2">跨境商品</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="自动内容规则" prop="remAutoRules" v-if="ruleForm.remType!=1">
          <a-select v-model="ruleForm.remAutoRules" placeholder="请选择" style="width: 400px">
            <a-select-option v-for="(i,idy) in recommendRule" :key="idy" :value="i.code">
              {{ i.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import EditableCell from '../component/editableCell'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'HomeSetting',
  components: {
    EditableCell,
    CustomPagingDraggingList
  },
  data() {
    return {
      activeKey: 0,
      activeItem: {},
      tabList: [],
      tabSetName: '',
      visible: false,
      queryParams: {
        homeModularDetailStatus: 0,
        homeModularId: 0
      },
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' },
          width: '70px'
        },
        {
          title: '图片/视频',
          dataIndex: 'modularDetailImg',
          slots: { title: 'customTitle' },
          width: '150px',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '标题',
          width: '28%',
          dataIndex: 'modularDetailTitle'
        },
        {
          title: '内容类型',
          dataIndex: 'modularContentType',
          scopedSlots: { customRender: 'contentSlots' }
        },
        {
          title: '投放时间',
          dataIndex: 'modularActiveTime'
        },
        {
          title: '状态',
          dataIndex: 'modularActiveStatus',
          width: '90px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      loadPromise: params => this.getModularListPromise(params),
      ruleForm: {},
      rules: {
        remModularName: [{ required: true, message: '请输入栏目名称', trigger: ['blur', 'change'] }],
        remCatalogId: [{ required: true, message: '请选择品类来源', trigger: ['blur', 'change'] }],
        remAutoRules: [{ required: true, message: '请选择自动内容规则', trigger: ['blur', 'change'] }]
      },
      recommendRule: [],
      proTypeList: [],
      isCloseMerchandise: false, //跨境直连设置:0=关闭 1=芥舟科技
      merchantId: this.$store.getters.userInfo.merchantId
    }
  },
  created() {
    this.getModularGroup()
    this.getRecommendContextRule()
  },
  activated() {
    if (this.$route.query.updateFlag) {
      this.$refs.table.refresh(true)
    }
  },
  mounted() {
    this.getProTypeList()
    this.getCloseMerchandise() //查询运营商是否开通跨境设置
  },
  methods: {
    getCloseMerchandise() { //查询运营商是否开通跨境设置
      this.getHttpServices().getUserService().post('user/merchantInfo/queryMerchantCrossBorderDirectOpen', {
        merchantId: this.merchantId
      }).then(res => {
        this.isCloseMerchandise = res.crossBorderDirect == 1 ? true : false
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getProTypeList() {
      this.getHttpServices().getApiService().post('homeMerchant/getMerchantNewField/' + this.$store.getters.userInfo.merchantId)
        .then(res => {
          if (res.productCatalogList && res.productCatalogList.length) {
            let allProCategoryList = this.getAppConstants().getProductTypeList()
            res.productCatalogList.forEach(item => {
              allProCategoryList.forEach(v => {
                if (item === v.code) this.proTypeList.push(v)
              })
            })
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    restFrom() { //重置
      this.ruleForm = {
        remModularName: '',
        remType: 1,
        remCatalogId: undefined,
        remAutoRules: undefined,
        commodityType: 0
      }
    },
    getRecommendContextRule() {//获取推荐内容规则枚举
      this.getHttpServices().getBaseService().get('base/sysCode/getRecommendContextRule').then(res => {
        this.recommendRule = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        remAutoRules: this.ruleForm.remType == 1 ? undefined : this.ruleForm.remAutoRules,
        remCatalogId: this.ruleForm.remType == 1 ? [] : this.ruleForm.remCatalogId,
        remModularId: this.activeItem.homeModularId,
        remModularName: this.ruleForm.remModularName,
        remType: this.ruleForm.remType,
        commodityType: this.ruleForm.commodityType
      }
      this.getHttpServices().getUserService().post('homepage/recommend/save/saveHomeModularAutoRecommendSettings', parms).then(res => {
        this.$message.success('保存成功')
        this.visible = false
        this.updateModularGroup()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    callback(key) {
      this.activeKey = key
      this.restFrom()
      this.activeItem = this.tabList[key]
      this.queryParams.homeModularId = this.tabList[key].homeModularId
      this.ruleForm.remModularName = this.tabList[key].homeModularName
      if (this.activeKey == 0) {
        this.queryParams.homeModularDetailStatus = 0
      }
      this.$refs.table.refresh(true)
    },
    getAutoRecommendByMerchantIdAndModularId(modularId) {
      this.getHttpServices().getUserService().get('homepage/recommend/get/getAutoRecommendByMerchantIdAndModularId/' + modularId).then(res => {
        /*if(res.remCatalogId && res.remCatalogId.includes(5) && !this.isCloseMerchandise){

        }*/
        res.commodityType = res.commodityType ? res.commodityType : 0 //百货类型
        this.ruleForm = res
        this.ruleForm.remAutoRules = this.ruleForm.remAutoRules ? this.ruleForm.remAutoRules : undefined
        this.ruleForm.remCatalogId = this.ruleForm.remCatalogId ? this.ruleForm.remCatalogId : undefined
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    setRecommendationRules() {
      this.getAutoRecommendByMerchantIdAndModularId(this.activeItem.homeModularId)
      this.visible = true
    },
    // 获取tab栏数据接口
    getModularGroup() {
      this.getHttpServices().getUserService().get('homepage/recommend/get/modularGroup')
        .then(res => {
          this.tabList = res
          this.activeItem = this.tabList[0]
          this.queryParams.homeModularId = res[0].homeModularId
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取表格数据接口
    getModularListPromise(params) {
      if (params.homeModularId != 0) {
        return this.getHttpServices().getUserService().post('homepage/recommend/get/modularDetailList', params)
      } else {
        return new Promise(resolve => {
          const result = {
            pageSize: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    },
    onOrderChange(e) {
      this.queryParams.homeModularDetailStatus = e.target.value
      this.$refs.table.refresh(true)
    },
    handleContent(modularDetailId) {
      this.$router.push({
        name: 'AddNewContent',
        query: {
          homeModularId: this.activeItem.homeModularId,
          modularDetailId: modularDetailId,
          modularClassId: this.activeKey,
          homeModularName: this.activeItem.homeModularName
        }
      })
    },
    // 删除
    deleteEvent(item) {
      let params = new Object()
      params.modularDetailId = item.modularDetailId
      this.getHttpServices().getUserService().post('homepage/recommend/del/modularDetail', params)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 拖拽排序功能
    onDraggable(params) {
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.modularDetailId
      })
      this.getHttpServices().getUserService().post('homepage/recommend/update/updateBatchModularDetailSerial', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 排序
    onCellChange(modularDetailId, value) {
      let params = new Object()
      params.modularDetailId = modularDetailId
      params.modularDetailSerial = value
      this.getHttpServices().getUserService().post('homepage/recommend/update/modularDetailSerial', params)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 更新TAB栏数据
    updateModularGroup() {
      this.getHttpServices().getUserService().get('homepage/recommend/get/modularGroup')
        .then(res => {
          this.tabList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.image-table {
  width: 120px;
  height: 50px;
}

.tr {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  text-align: right;

  a {
    padding-left: 10px;
  }
}
</style>